import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export class Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
};

export class AuthInput {
  code?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  redirectUri?: InputMaybe<Scalars['String']>;
};

export class AuthType {
  token: Scalars['String'];
  user?: Maybe<User>;
};

export class Country {
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  flag?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  unity?: Maybe<Array<Unity>>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<Array<User>>;
};

export class CountryPage {
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  pageSize: Scalars['Int'];
  previousPage: Scalars['Boolean'];
  results?: Maybe<Array<Country>>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class CreateCountryInput {
  flag?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export class CreateUnityInput {
  countryId: Scalars['String'];
  name: Scalars['String'];
  status?: InputMaybe<UnityStatus>;
};

export class CreateUserInput {
  costCenter: Scalars['String'];
  countryId: Scalars['String'];
  email: Scalars['String'];
  gender: UserGender;
  jobRoleId: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
  photoUrl?: InputMaybe<Scalars['String']>;
  profile?: UserProfile;
  re: Scalars['String'];
  status?: UserStatus;
  unityId: Scalars['String'];
};

export class DefaultMessage {
  message: Scalars['String'];
  status: Scalars['Int'];
};

export class DocumentsAcceptanceSalesforceDto {
  EUR_Accept_Quota__c?: Maybe<Scalars['String']>;
  EUR_Attachment_URL_1__c?: Maybe<Scalars['String']>;
  EUR_End_Date__c?: Maybe<Scalars['String']>;
  EUR_Justify_Leave__c?: Maybe<Scalars['String']>;
  EUR_Leave_Reasons__c?: Maybe<Scalars['String']>;
  EUR_Previous_Quota__c?: Maybe<Scalars['String']>;
  EUR_RE_Id__c?: Maybe<Scalars['String']>;
  EUR_Response_Info__c?: Maybe<Scalars['String']>;
  EUR_Start_Date__c?: Maybe<Scalars['String']>;
  EUR_Status__c?: Maybe<Scalars['String']>;
  EUR_Target_Quota__c?: Maybe<Scalars['String']>;
  EUR_Territory__c?: Maybe<Scalars['String']>;
  EUR_Title__c?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
  Owner: SalesforceOwnerDto;
  attributes: SalesforceAttributesDto;
};

export class DocumentsAcceptanceSalesforceResponseDto {
  done: Scalars['Boolean'];
  records: Array<DocumentsAcceptanceSalesforceDto>;
  totalSize: Scalars['Float'];
};

export class JobRole {
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user: JobRole;
};

export class MedicalVisit {
  ACOMPANHADAPOR?: Maybe<Scalars['String']>;
  BAIRRO?: Maybe<Scalars['String']>;
  CIDADE?: Maybe<Scalars['String']>;
  COMENTARIOS?: Maybe<Scalars['String']>;
  CRM?: Maybe<Scalars['String']>;
  DATA_VISITA?: Maybe<Scalars['String']>;
  ENDERECO?: Maybe<Scalars['String']>;
  EUR_RE_Id__c?: Maybe<Scalars['String']>;
  HORA_VISITA?: Maybe<Scalars['String']>;
  NOME_MEDICO?: Maybe<Scalars['String']>;
  NUMERO?: Maybe<Scalars['String']>;
  NUMEROVISITA?: Maybe<Scalars['String']>;
  PROXIMAVISITA?: Maybe<Scalars['String']>;
  SETOR?: Maybe<Scalars['String']>;
  UF?: Maybe<Scalars['String']>;
};

export class MedicalVisitAccountVodDto {
  Name: Scalars['String'];
  National_ID_NWK__c: Scalars['String'];
};

export class MedicalVisitPage {
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  pageSize: Scalars['Int'];
  previousPage: Scalars['Boolean'];
  results?: Maybe<Array<MedicalVisit>>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class MedicalVisitSalesforceDto {
  Account_vod__r: MedicalVisitAccountVodDto;
  Address_vod__c?: Maybe<Scalars['String']>;
  Call_Comments_vod__c?: Maybe<Scalars['String']>;
  Call_Date_vod__c?: Maybe<Scalars['String']>;
  Call_Datetime_vod__c?: Maybe<Scalars['String']>;
  EUR_Accompanied_By__c?: Maybe<Scalars['String']>;
  EUR_RE_Id__c?: Maybe<Scalars['String']>;
  Next_Call_Notes_vod__c?: Maybe<Scalars['String']>;
  Territory_vod__c?: Maybe<Scalars['String']>;
  attributes: SalesforceAttributesDto;
};

export class MedicalVisitSalesforceResponseDto {
  done: Scalars['Boolean'];
  records: Array<MedicalVisitSalesforceDto>;
  totalSize: Scalars['Float'];
};

export class Mutation {
  /** Create new Country */
  createCountry: Country;
  /** Create new Unity */
  createUnity: Unity;
  /** Create new User */
  createUser: User;
  /** Delete Country by Id */
  deleteCountry: DefaultMessage;
  /** Delete Unity by Id */
  deleteUnity: DefaultMessage;
  /** Delete User by Id */
  deleteUser: DefaultMessage;
  login: AuthType;
  testTokenSalesforce: SalesforceTokenResponse;
  /** Update Country By Id */
  updateCountry: Country;
  /** Update Unity By Id */
  updateUnity: Unity;
  /** Update User by Id */
  updateUser: User;
};


export class MutationCreateCountryArgs {
  data: CreateCountryInput;
};


export class MutationCreateUnityArgs {
  data: CreateUnityInput;
};


export class MutationCreateUserArgs {
  data: CreateUserInput;
};


export class MutationDeleteCountryArgs {
  id: Scalars['String'];
};


export class MutationDeleteUnityArgs {
  id: Scalars['String'];
};


export class MutationDeleteUserArgs {
  id: Scalars['String'];
};


export class MutationLoginArgs {
  data: AuthInput;
};


export class MutationUpdateCountryArgs {
  data: UpdateCountryInput;
};


export class MutationUpdateUnityArgs {
  data: UpdateUnityInput;
};


export class MutationUpdateUserArgs {
  data: UpdateUserInput;
};

export class OwnerDto {
  Name: Scalars['String'];
  attributes: SalesforceAttributesDto;
};

export class Query {
  Hello: Scalars['String'];
  /** Return Country by Id */
  countryById: Country;
  /** Return User Logged */
  currentUser: User;
  /** Return JobRole By ID */
  jobRoleById: JobRole;
  /** List All Job Roles */
  jobRoles: Array<JobRole>;
  /** List All Country */
  listCountry: Array<Country>;
  listDataSet: Array<Scalars['String']>;
  /** List All Unity */
  listUnity: Array<Unity>;
  /** Return all countries paged */
  searchAllCountry: CountryPage;
  /** Return all unities paged */
  searchAllUnity: UnityPage;
  /** Return All users paged */
  searchAllUser: UserPage;
  searchDocumentsAcceptanceSalesforce: DocumentsAcceptanceSalesforceResponseDto;
  searchMedicalVisit: MedicalVisitPage;
  searchMedicalVisitSalesforce: MedicalVisitSalesforceResponseDto;
  searchQuotaAcceptance: QuotaAcceptancePage;
  searchQuotaAcceptanceSalesforce: QuotaAcceptanceSalesforceResponseDto;
  searchTimeTracking: TimeTrackingResponseDto;
  searchWorkingHours: WorkingHoursPage;
  /** Return Unity by Country Id */
  unityByCountryId: Array<Unity>;
  /** Return Unity by Id */
  unityById: Unity;
  /** Return User By Id */
  userById: User;
};


export class QueryCountryByIdArgs {
  id: Scalars['String'];
};


export class QueryJobRoleByIdArgs {
  id: Scalars['String'];
};


export class QuerySearchAllCountryArgs {
  data: SearchCountryInput;
};


export class QuerySearchAllUnityArgs {
  data: SearchUnityInput;
};


export class QuerySearchAllUserArgs {
  data: SearchUserInput;
};


export class QuerySearchDocumentsAcceptanceSalesforceArgs {
  input: SearchInput;
};


export class QuerySearchMedicalVisitArgs {
  input: SearchMedicalVisitInput;
};


export class QuerySearchMedicalVisitSalesforceArgs {
  input: SearchInput;
};


export class QuerySearchQuotaAcceptanceArgs {
  input: SearchInput;
};


export class QuerySearchQuotaAcceptanceSalesforceArgs {
  input: SearchInput;
};


export class QuerySearchTimeTrackingArgs {
  input: SearchInput;
};


export class QuerySearchWorkingHoursArgs {
  input: SearchInput;
};


export class QueryUnityByCountryIdArgs {
  countryId: Scalars['String'];
};


export class QueryUnityByIdArgs {
  id: Scalars['String'];
};


export class QueryUserByIdArgs {
  id: Scalars['String'];
};

export class QuotaAcceptance {
  COTA_PREVISTA?: Maybe<Scalars['String']>;
  COTA_REALIZADA?: Maybe<Scalars['String']>;
  DATAHORAACEITE?: Maybe<Scalars['String']>;
  EUR_Accept_Quota__c?: Maybe<Scalars['String']>;
  EUR_Attachment_URL_1__c?: Maybe<Scalars['String']>;
  EUR_End_Date__c?: Maybe<Scalars['String']>;
  EUR_Justify_Leave__c?: Maybe<Scalars['String']>;
  EUR_Leave_Reasons__c?: Maybe<Scalars['String']>;
  EUR_Reference_Month__c?: Maybe<Scalars['String']>;
  EUR_Response_Info__c?: Maybe<Scalars['String']>;
  EUR_Start_Date__c?: Maybe<Scalars['String']>;
  EUR_Status__c?: Maybe<Scalars['String']>;
  EUR_Territory__c?: Maybe<Scalars['String']>;
  EUR_Title__c?: Maybe<Scalars['String']>;
  MOTIVO_AFASTAMENTO?: Maybe<Scalars['String']>;
  NOME?: Maybe<Scalars['String']>;
  RE?: Maybe<Scalars['String']>;
  SETOR?: Maybe<Scalars['String']>;
};

export class QuotaAcceptancePage {
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  pageSize: Scalars['Int'];
  previousPage: Scalars['Boolean'];
  results?: Maybe<Array<QuotaAcceptance>>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class QuotaAcceptanceSalesforceDto {
  EUR_Accept_Quota__c?: Maybe<Scalars['String']>;
  EUR_End_Date__c?: Maybe<Scalars['String']>;
  EUR_Justify_Leave__c?: Maybe<Scalars['String']>;
  EUR_Leave_Reasons__c?: Maybe<Scalars['String']>;
  EUR_Previous_Quota__c?: Maybe<Scalars['String']>;
  EUR_RE_Id__c?: Maybe<Scalars['String']>;
  EUR_Reference_Month__c?: Maybe<Scalars['String']>;
  EUR_Response_Info__c?: Maybe<Scalars['String']>;
  EUR_Start_Date__c?: Maybe<Scalars['String']>;
  EUR_Status__c?: Maybe<Scalars['String']>;
  EUR_Target_Quota__c?: Maybe<Scalars['String']>;
  EUR_Territory__c?: Maybe<Scalars['String']>;
  EUR_Title__c?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
  Owner: SalesforceOwnerDto;
  attributes: SalesforceAttributesDto;
};

export class QuotaAcceptanceSalesforceResponseDto {
  done: Scalars['Boolean'];
  records: Array<QuotaAcceptanceSalesforceDto>;
  totalSize: Scalars['Float'];
};

export class SalesforceAttributesDto {
  type: Scalars['String'];
  url: Scalars['String'];
};

export class SalesforceOwnerDto {
  Name: Scalars['String'];
};

export class SalesforceTokenResponse {
  access_token?: Maybe<Scalars['String']>;
  api_instance_url?: Maybe<Scalars['String']>;
  expires_in?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  instance_url?: Maybe<Scalars['String']>;
  issued_at?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  signature?: Maybe<Scalars['String']>;
  token_type?: Maybe<Scalars['String']>;
};

export class SearchCountryInput {
  end?: InputMaybe<Scalars['DateTime']>;
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['DateTime']>;
};

export class SearchInput {
  crm?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['String']>;
  medicName?: InputMaybe<Scalars['String']>;
  nameUser?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  re?: InputMaybe<Scalars['String']>;
  sector?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['String']>;
};

export class SearchMedicalVisitInput {
  crm?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['String']>;
  medicName?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  re?: InputMaybe<Scalars['String']>;
  sector?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['String']>;
};

export class SearchUnityInput {
  countryId?: InputMaybe<Array<Scalars['String']>>;
  end?: InputMaybe<Scalars['DateTime']>;
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Array<Scalars['String']>>;
};

export class SearchUserInput {
  countryId?: InputMaybe<Array<Scalars['String']>>;
  end?: InputMaybe<Scalars['DateTime']>;
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  profile?: InputMaybe<Array<Scalars['String']>>;
  start?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Array<Scalars['String']>>;
  unityId?: InputMaybe<Array<Scalars['String']>>;
};

export class TimeTrackingRecordDto {
  End_Time__c?: Maybe<Scalars['String']>;
  Justification__c?: Maybe<Scalars['String']>;
  Lunch_Pause_End__c?: Maybe<Scalars['String']>;
  Lunch_Pause__c?: Maybe<Scalars['String']>;
  Owner: OwnerDto;
  RE_Id__c: Scalars['String'];
  Reference_Date__c?: Maybe<Scalars['String']>;
  Start_Time__c?: Maybe<Scalars['String']>;
  Territory_Name__c?: Maybe<Scalars['String']>;
  attributes: SalesforceAttributesDto;
};

export class TimeTrackingResponseDto {
  done: Scalars['Boolean'];
  records: Array<TimeTrackingRecordDto>;
  totalSize: Scalars['Float'];
};

export class Unity {
  country?: Maybe<Country>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  status: UnityStatus;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<Array<User>>;
};

export class UnityPage {
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  pageSize: Scalars['Int'];
  previousPage: Scalars['Boolean'];
  results?: Maybe<Array<Unity>>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

/** Status da unidade */
export enum UnityStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export class UpdateCountryInput {
  flag?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};

export class UpdateUnityInput {
  countryId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<UnityStatus>;
};

export class UpdateUserInput {
  costCenter?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<UserGender>;
  id: Scalars['String'];
  jobRoleId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  photoUrl?: InputMaybe<Scalars['String']>;
  profile?: InputMaybe<UserProfile>;
  re?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<UserStatus>;
  unityId?: InputMaybe<Scalars['String']>;
};

export class User {
  costCenter?: Maybe<Scalars['String']>;
  country?: Maybe<Country>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  gender: UserGender;
  id: Scalars['ID'];
  jobRole?: Maybe<JobRole>;
  name: Scalars['String'];
  phone: Scalars['String'];
  photoUrl?: Maybe<Scalars['String']>;
  profile: UserProfile;
  re: Scalars['String'];
  status: UserStatus;
  unity?: Maybe<Unity>;
  updatedAt: Scalars['DateTime'];
};

/** Gênero do usuário */
export enum UserGender {
  F = 'F',
  M = 'M',
  O = 'O'
}

export class UserPage {
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  pageSize: Scalars['Int'];
  previousPage: Scalars['Boolean'];
  results?: Maybe<Array<User>>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

/** Perfil do usuário */
export enum UserProfile {
  Admin = 'ADMIN',
  User = 'USER'
}

/** Status do usuário */
export enum UserStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Pending = 'PENDING'
}

export class WorkingHours {
  ALMOCO_CAFE?: Maybe<Scalars['String']>;
  DATA?: Maybe<Scalars['String']>;
  INICIO?: Maybe<Scalars['String']>;
  INICIO_REGISTRADO_POR?: Maybe<Scalars['String']>;
  JUSTIFICATIVA?: Maybe<Scalars['String']>;
  NOME_FUNCIONARIO?: Maybe<Scalars['String']>;
  PAUSA_REGISTRADA_POR?: Maybe<Scalars['String']>;
  RE?: Maybe<Scalars['String']>;
  SETOR?: Maybe<Scalars['String']>;
  TERMINO?: Maybe<Scalars['String']>;
  TERMINO_REGISTRADO_POR?: Maybe<Scalars['String']>;
  UF?: Maybe<Scalars['String']>;
};

export class WorkingHoursPage {
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  pageSize: Scalars['Int'];
  previousPage: Scalars['Boolean'];
  results?: Maybe<Array<WorkingHours>>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export type AuthTypeFragment = { token: string, user?: { id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null } | null };

export type UserFragment = { id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null };

export type DefaultMessageFragment = { message: string, status: number };

export type UnityPageFragment = { totalCount: number, pageSize: number, currentPage: number, totalPage: number, previousPage: boolean, nextPage: boolean, results?: Array<{ id: string, name: string, status: UnityStatus, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: Array<{ id: string, name: string }> | null }> | null };

export type UnityFragment = { id: string, name: string, status: UnityStatus, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null }> | null };

export type JobRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type JobRolesQuery = { jobRoles: Array<{ id: string, name: string }> };

export type ListUnityQueryVariables = Exact<{ [key: string]: never; }>;


export type ListUnityQuery = { listUnity: Array<{ id: string, name: string }> };

export type SearchQuotaAcceptanceQueryVariables = Exact<{
  data: SearchInput;
}>;


export type SearchQuotaAcceptanceQuery = { searchQuotaAcceptance: { currentPage: number, nextPage: boolean, pageSize: number, previousPage: boolean, totalCount: number, totalPage: number, results?: Array<{ RE?: string | null, SETOR?: string | null, NOME?: string | null, COTA_REALIZADA?: string | null, COTA_PREVISTA?: string | null, DATAHORAACEITE?: string | null, MOTIVO_AFASTAMENTO?: string | null, EUR_Status__c?: string | null, EUR_Title__c?: string | null, EUR_Start_Date__c?: string | null, EUR_End_Date__c?: string | null, EUR_Response_Info__c?: string | null, EUR_Attachment_URL_1__c?: string | null, EUR_Reference_Month__c?: string | null }> | null } };

export type SearchMedicalVisitQueryVariables = Exact<{
  data: SearchMedicalVisitInput;
}>;


export type SearchMedicalVisitQuery = { searchMedicalVisit: { currentPage: number, nextPage: boolean, pageSize: number, previousPage: boolean, totalCount: number, totalPage: number, results?: Array<{ SETOR?: string | null, NUMEROVISITA?: string | null, ACOMPANHADAPOR?: string | null, DATA_VISITA?: string | null, HORA_VISITA?: string | null, NOME_MEDICO?: string | null, COMENTARIOS?: string | null, BAIRRO?: string | null, CIDADE?: string | null, ENDERECO?: string | null, NUMERO?: string | null, UF?: string | null, PROXIMAVISITA?: string | null, CRM?: string | null, EUR_RE_Id__c?: string | null }> | null } };

export type SearchWorkingHoursQueryVariables = Exact<{
  data: SearchInput;
}>;


export type SearchWorkingHoursQuery = { searchWorkingHours: { currentPage: number, nextPage: boolean, pageSize: number, previousPage: boolean, totalCount: number, totalPage: number, results?: Array<{ RE?: string | null, SETOR?: string | null, NOME_FUNCIONARIO?: string | null, UF?: string | null, DATA?: string | null, INICIO?: string | null, ALMOCO_CAFE?: string | null, TERMINO?: string | null, INICIO_REGISTRADO_POR?: string | null, TERMINO_REGISTRADO_POR?: string | null, PAUSA_REGISTRADA_POR?: string | null, JUSTIFICATIVA?: string | null }> | null } };

export type CreateUnityMutationVariables = Exact<{
  input: CreateUnityInput;
}>;


export type CreateUnityMutation = { createUnity: { id: string, name: string, status: UnityStatus, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null }> | null } };

export type UpdateUnityMutationVariables = Exact<{
  input: UpdateUnityInput;
}>;


export type UpdateUnityMutation = { updateUnity: { id: string, name: string, status: UnityStatus, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null }> | null } };

export type DeleteUnityMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteUnityMutation = { deleteUnity: { message: string, status: number } };

export type LoginMutationVariables = Exact<{
  data: AuthInput;
}>;


export type LoginMutation = { login: { token: string, user?: { id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null } | null } };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { currentUser: { id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null } };

export type SearchAllUserQueryVariables = Exact<{
  data: SearchUserInput;
}>;


export type SearchAllUserQuery = { searchAllUser: { currentPage: number, nextPage: boolean, pageSize: number, previousPage: boolean, totalCount: number, totalPage: number, results?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null }> | null } };

export type CreateUserMutationVariables = Exact<{
  data: CreateUserInput;
}>;


export type CreateUserMutation = { createUser: { id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null } };

export type UpdateUserMutationVariables = Exact<{
  data: UpdateUserInput;
}>;


export type UpdateUserMutation = { updateUser: { id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null } };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteUserMutation = { deleteUser: { message: string, status: number } };

export const UserFragmentDoc = gql`
    fragment User on User {
  id
  name
  email
  re
  phone
  gender
  profile
  status
  costCenter
  photoUrl
  createdAt
  updatedAt
  deletedAt
  status
  unity {
    id
    name
  }
  jobRole {
    id
    name
  }
}
    `;
export const AuthTypeFragmentDoc = gql`
    fragment AuthType on AuthType {
  token
  user {
    ...User
  }
}
    ${UserFragmentDoc}`;
export const DefaultMessageFragmentDoc = gql`
    fragment DefaultMessage on DefaultMessage {
  message
  status
}
    `;
export const UnityPageFragmentDoc = gql`
    fragment UnityPage on UnityPage {
  totalCount
  pageSize
  currentPage
  totalPage
  previousPage
  nextPage
  results {
    id
    name
    status
    createdAt
    updatedAt
    deletedAt
    user {
      id
      name
    }
  }
}
    `;
export const UnityFragmentDoc = gql`
    fragment Unity on Unity {
  id
  name
  status
  createdAt
  updatedAt
  deletedAt
  user {
    ...User
  }
}
    ${UserFragmentDoc}`;
export const JobRolesDocument = gql`
    query jobRoles {
  jobRoles {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class JobRolesGQL extends Apollo.Query<JobRolesQuery, JobRolesQueryVariables> {
    document = JobRolesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListUnityDocument = gql`
    query listUnity {
  listUnity {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListUnityGQL extends Apollo.Query<ListUnityQuery, ListUnityQueryVariables> {
    document = ListUnityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchQuotaAcceptanceDocument = gql`
    query searchQuotaAcceptance($data: SearchInput!) {
  searchQuotaAcceptance(input: $data) {
    currentPage
    nextPage
    pageSize
    previousPage
    totalCount
    totalPage
    results {
      RE
      SETOR
      NOME
      COTA_REALIZADA
      COTA_PREVISTA
      DATAHORAACEITE
      MOTIVO_AFASTAMENTO
      EUR_Status__c
      EUR_Title__c
      EUR_Start_Date__c
      EUR_End_Date__c
      EUR_Response_Info__c
      EUR_Attachment_URL_1__c
      EUR_Reference_Month__c
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchQuotaAcceptanceGQL extends Apollo.Query<SearchQuotaAcceptanceQuery, SearchQuotaAcceptanceQueryVariables> {
    document = SearchQuotaAcceptanceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchMedicalVisitDocument = gql`
    query searchMedicalVisit($data: SearchMedicalVisitInput!) {
  searchMedicalVisit(input: $data) {
    currentPage
    nextPage
    pageSize
    previousPage
    totalCount
    totalPage
    results {
      SETOR
      NUMEROVISITA
      ACOMPANHADAPOR
      DATA_VISITA
      HORA_VISITA
      NOME_MEDICO
      COMENTARIOS
      BAIRRO
      CIDADE
      ENDERECO
      NUMERO
      UF
      PROXIMAVISITA
      CRM
      EUR_RE_Id__c
      COMENTARIOS
      ENDERECO
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchMedicalVisitGQL extends Apollo.Query<SearchMedicalVisitQuery, SearchMedicalVisitQueryVariables> {
    document = SearchMedicalVisitDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchWorkingHoursDocument = gql`
    query searchWorkingHours($data: SearchInput!) {
  searchWorkingHours(input: $data) {
    currentPage
    nextPage
    pageSize
    previousPage
    totalCount
    totalPage
    results {
      RE
      SETOR
      NOME_FUNCIONARIO
      UF
      DATA
      INICIO
      ALMOCO_CAFE
      TERMINO
      INICIO_REGISTRADO_POR
      TERMINO_REGISTRADO_POR
      PAUSA_REGISTRADA_POR
      JUSTIFICATIVA
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchWorkingHoursGQL extends Apollo.Query<SearchWorkingHoursQuery, SearchWorkingHoursQueryVariables> {
    document = SearchWorkingHoursDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUnityDocument = gql`
    mutation createUnity($input: CreateUnityInput!) {
  createUnity(data: $input) {
    ...Unity
  }
}
    ${UnityFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUnityGQL extends Apollo.Mutation<CreateUnityMutation, CreateUnityMutationVariables> {
    document = CreateUnityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUnityDocument = gql`
    mutation updateUnity($input: UpdateUnityInput!) {
  updateUnity(data: $input) {
    ...Unity
  }
}
    ${UnityFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUnityGQL extends Apollo.Mutation<UpdateUnityMutation, UpdateUnityMutationVariables> {
    document = UpdateUnityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteUnityDocument = gql`
    mutation deleteUnity($id: String!) {
  deleteUnity(id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteUnityGQL extends Apollo.Mutation<DeleteUnityMutation, DeleteUnityMutationVariables> {
    document = DeleteUnityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoginDocument = gql`
    mutation login($data: AuthInput!) {
  login(data: $data) {
    ...AuthType
  }
}
    ${AuthTypeFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoginGQL extends Apollo.Mutation<LoginMutation, LoginMutationVariables> {
    document = LoginDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CurrentUserDocument = gql`
    query currentUser {
  currentUser {
    ...User
  }
}
    ${UserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CurrentUserGQL extends Apollo.Query<CurrentUserQuery, CurrentUserQueryVariables> {
    document = CurrentUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchAllUserDocument = gql`
    query searchAllUser($data: SearchUserInput!) {
  searchAllUser(data: $data) {
    currentPage
    nextPage
    pageSize
    previousPage
    totalCount
    totalPage
    results {
      ...User
    }
  }
}
    ${UserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchAllUserGQL extends Apollo.Query<SearchAllUserQuery, SearchAllUserQueryVariables> {
    document = SearchAllUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUserDocument = gql`
    mutation createUser($data: CreateUserInput!) {
  createUser(data: $data) {
    ...User
  }
}
    ${UserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUserGQL extends Apollo.Mutation<CreateUserMutation, CreateUserMutationVariables> {
    document = CreateUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserDocument = gql`
    mutation updateUser($data: UpdateUserInput!) {
  updateUser(data: $data) {
    ...User
  }
}
    ${UserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserGQL extends Apollo.Mutation<UpdateUserMutation, UpdateUserMutationVariables> {
    document = UpdateUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteUserDocument = gql`
    mutation deleteUser($id: String!) {
  deleteUser(id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteUserGQL extends Apollo.Mutation<DeleteUserMutation, DeleteUserMutationVariables> {
    document = DeleteUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }